export const OPTIONS = {
  // we are using 50% of the component visibility to show the transition
  threshold: 0.5,
};
